import { render, staticRenderFns } from "./SettingsCardMailTemplatesContactForm.vue?vue&type=template&id=4be00d92&scoped=true"
import script from "./SettingsCardMailTemplatesContactForm.vue?vue&type=script&lang=ts"
export * from "./SettingsCardMailTemplatesContactForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be00d92",
  null
  
)

export default component.exports